import {
  PRODUCT,
  HEADER,
  ASSIGNMENT,
  ACTIVITY,
  DESCRIPTION,
  ROOM_SETTINGS_TODO,
  PROOF_OF_COMPLETION,
  PREVIOUS_PRODUCT,
} from "./_common";
import { PickUpTask, CompleteTask } from "../actions/index";

export default {
  fields: [
    HEADER,
    PRODUCT,
    DESCRIPTION("reason", "typeOfTaskString", "", 0, "dailyMaintenanceString"),
    ROOM_SETTINGS_TODO,
    PREVIOUS_PRODUCT,
    PROOF_OF_COMPLETION,
    DESCRIPTION("media_name", "mediaNameString", ""),
    DESCRIPTION("description", "description4String", ""),
    ASSIGNMENT(),
    ACTIVITY,
  ],
  actions: [PickUpTask, CompleteTask],
};
